<div class="modal-header border-bottom p-3">
  <h5 id="offcanvasAddUserLabel" class="offcanvas-title">
    {{ "BarcodeScan" | translate }}
    &nbsp;&nbsp;&nbsp;&nbsp;
    {{ drugName }}
  </h5>
  <button
    type="button"
    class="btn-close-modal btn-icon btn-close"
    (click)="callParent('closeUid',undefined)"
    aria-label="Close"
  ></button>
</div>
<div class="modal-body mx-0 flex-grow-0">
  <div class="fourth-box row border-card mx-1 py-2">
    <div class="col-12">
      <p>{{ 'UIDScanDescription' | translate }}</p>
    </div>
    <ng-container *ngFor="let item of barcodeList; let i = index">
      <div
        class="barcode-box mt-2"
        [ngClass]="{
          'col-11': ActiveAddButton == true,
          'col-12': ActiveAddButton == false
        }"
      >
        <!-- <h6 for="Amount">
          {{ "barcode" | translate }}
        </h6> -->
        <p class="m-0">
          {{ i + 1 }} - 
        </p>
        <input id="barcode" type="text" class="form-control input" [(ngModel)]="item.uId"/>
      </div>
    </ng-container>
    <div class="col-1 mt-2">
      <button
        class="btn btn-primary Focusable iner-Focusable"
        (click)="addNewBarcode()"
        *ngIf="ActiveAddButton"
      >
        <i class="fa-solid fa-plus"></i>
      </button>
    </div>
  </div>
</div>
<div class="modal-footer border-top p-3 justify-content-center">
  <button type="submit" class="btn btn-primary me-sm-3 me-1 data-submit"
  (click)="saveBarcode()">
    {{ "Save" | translate }}
  </button>
</div>
